export default __webpack_public_path__ + "static/media/solucao1.2ec6b23f.png";